module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pluviometric-chart-container"
  }, [(_vm.pdfUrl) ? _c('div', {
    ref: "pdfWrapper",
    staticClass: "pdf-wrapper",
    on: {
      "mouseenter": _vm.showControls,
      "mouseleave": _vm.startHideTimer,
      "mousemove": _vm.showControls,
      "scroll": _vm.handleScroll
    }
  }, [_c('div', {
    staticClass: "pdf-container"
  }, [_c('vue-pdf-embed', {
    ref: "pdfEmbed",
    attrs: {
      "source": _vm.pdfUrl,
      "width": _vm.calculatedWidth,
      "text-layer": true,
      "annotation-layer": true
    },
    on: {
      "loaded": _vm.handleDocumentLoad
    }
  })], 1)]) : _c('div', {
    staticClass: "no-pdf-message"
  }, [_c('p', [_vm._v("No hay PDF disponible")])]), _vm._v(" "), (_vm.pdfUrl && _vm.showToolbar) ? _c('div', {
    staticClass: "pdf-toolbar",
    class: {
      'fade-in': _vm.showToolbar,
      'fade-out': !_vm.showToolbar
    },
    on: {
      "mouseenter": _vm.showControls,
      "mouseleave": _vm.startHideTimer
    }
  }, [_c('div', {
    staticClass: "toolbar-section"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "disabled": _vm.page <= 1
    },
    on: {
      "click": function($event) {
        return _vm.scrollToPage(_vm.page - 1)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "small": ""
    }
  }, [_vm._v("mdi-chevron-left")])], 1), _vm._v(" "), _c('span', {
    staticClass: "page-info"
  }, [_vm._v(_vm._s(_vm.page) + " / " + _vm._s(_vm.pageCount))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "disabled": _vm.page >= _vm.pageCount
    },
    on: {
      "click": function($event) {
        return _vm.scrollToPage(_vm.page + 1)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "small": ""
    }
  }, [_vm._v("mdi-chevron-right")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "toolbar-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "toolbar-section"
  }, [_c('v-btn', {
    staticClass: "toolbar-btn",
    attrs: {
      "icon": "",
      "small": "",
      "disabled": _vm.scale <= 0.5
    },
    on: {
      "click": _vm.zoomOut
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-minus")])], 1), _vm._v(" "), _c('span', {
    staticClass: "zoom-info"
  }, [_vm._v(_vm._s(Math.round(_vm.scale * 100)) + "%")]), _vm._v(" "), _c('v-btn', {
    staticClass: "toolbar-btn",
    attrs: {
      "icon": "",
      "small": "",
      "disabled": _vm.scale >= 3
    },
    on: {
      "click": _vm.zoomIn
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus")])], 1)], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-826e5f4a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/PdfViewer.vue
// module id = 1743
// module chunks = 0